import cn from "classnames"
import { mergeClasses } from "@lib/css"

import type { ButtonHTMLAttributes } from "react"

type HamburgerButtonProps = {
  opened?: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>

export function HamburgerButton(props: HamburgerButtonProps) {
  const { opened = false, className, ...otherProps } = props

  const defaultClasses =
    "relative p-0 w-7.5 h-7.5 flex flex-col justify-between bg-transparent border-none cursor-pointer"
  const classes = mergeClasses(defaultClasses, className)

  return (
    <button className={classes} {...otherProps}>
      <span
        className={cn(
          "absolute right-0 left-0 h-px transform bg-black rounded-2xl transition-transform ease-in-out duration-200",
          {
            "top-[0.938rem] rotate-45": opened,
            "top-[0.469rem] rotate-0": !opened,
          },
        )}
      />
      <span
        className={cn(
          "absolute top-1/2 right-0 left-0 transform -translate-y-1/2 h-px bg-black rounded-2xl transition-opacity ease-in duration-100",
          {
            "opacity-0 invisible": opened,
            "opacity-100 visible": !opened,
          },
        )}
      />
      <span
        className={cn(
          "absolute right-0 left-0 h-px transform bg-black rounded-2xl transition-transform ease-in-out duration-200",
          {
            "bottom-3.5 -rotate-45": opened,
            "bottom-[0.469rem] rotate-0": !opened,
          },
        )}
      />
    </button>
  )
}
